import styles from "../../../styles/MobileNumberLogin.module.css";

// images
import LoginMobileNumberImg from "../../../assets/images/login-mobile-number-img.png";
import LegionLogo from "../../../assets/images/legion-logo.png";

// legion
import {
  Flex,
  Button,
  Text,
  Anchor,
  Textfield,
  Modal,
  Image,
} from "@legion-ui/core";

// hooks
import { useMobileNumberLogin } from "../../../hooks/useMobileNumberLogin";

export const MobileNumberLogin = () => {
  const {
    showModal,
    setShowModal,
    state,
    handleAddPhoneNumber,
    handleLogin,
    handleOTP,
  } = useMobileNumberLogin();

  return (
    <Flex width="100%" height="100%">
      <Modal
        show={showModal}
        onClose={() => setShowModal(false)}
        title="Select Verification Method"
        width="528px"
      >
        <Text as="p" color="tertiary500" margin="0 0 24px 0">
          Choose one of the methods below to get a verification code for
          continue your sign in process.
        </Text>

        <Button
          block
          center
          variant="outline"
          color="tertiary"
          onClick={() => handleOTP("SMS")}
        >
          SMS to {state.phoneNumber}
        </Button>
        <Button
          block
          center
          margin="24px 0"
          variant="outline"
          color="tertiary"
          onClick={() => handleOTP("WhatsApp")}
        >
          Send to {state.phoneNumber}
        </Button>

        <Text as="p" color="tertiary500" margin="0 0 24px 0">
          &#9432; Have issue to verify or change mobile number{" "}
          <Anchor href="/contact-us/mobile-number" color="primary500">
            Contact us
          </Anchor>
        </Text>
      </Modal>

      <Flex
        alignY="center"
        alignX="center"
        padding={["5rem 0", "26px 16px"]}
        width={["", "50%"]}
        className={styles.login__form}
      >
        <Flex
          direction="column"
          style={{ maxWidth: "464px", height: "min-content" }}
          mq={{
            padding: {
              md: "2rem 1rem",
            },
          }}
        >
          <Anchor href="/" block>
            <Image
              width="146px"
              margin="0 0 32px 0"
              src={LegionLogo}
              alt="legion logo"
            />
          </Anchor>
          <Text
            as="h3"
            size={["36px", "24px"]}
            weight="700"
            margin="0 0 12px 0"
            color="tertiary900"
          >
            Sign In
          </Text>
          <Text
            as="p"
            size={["16px", "14px"]}
            weight="400"
            margin="0 0 24px 0"
            color="tertiary500"
          >
            Welcome back! Sign in to access your account with your registered
            mobile phone number
          </Text>

          <Textfield
            before="+62"
            label="Mobile Number"
            placeholder="85123456XXXXX"
            type="number"
            status={state.status}
            message={state.errorMessage}
            onChange={handleAddPhoneNumber}
          />

          <Button margin="48px 0 32px 0" center onClick={handleLogin}>
            Login
          </Button>

          <div style={{ textAlign: "center" }}>
            <Text margin="0 0 40px 0" as="p" color="tertiary500">
              Don't have an account?{" "}
              <Anchor
                href="/register/mobile-number"
                weight="700"
                color="primary500"
              >
                Register
              </Anchor>
            </Text>
            <Text as="p" color="tertiary500">
              &#9432; Forgot your mobile number?
            </Text>
            <Anchor
              href="/contact-us/mobile-number"
              weight="700"
              color="primary500"
            >
              Contact Us
            </Anchor>
          </div>
        </Flex>
      </Flex>

      <Flex alignX="end" className={styles.login__image} width={["", "50%"]}>
        <Image
          width="auto"
          height="100%"
          src={LoginMobileNumberImg}
          fit="cover"
          alt="login mobile number as primary key image"
        />
      </Flex>
    </Flex>
  );
};
